import { ReaganData } from "./ReaganData.js";
import { PinnacleData } from "./PinnacleData.js";
import { SyncRunsOverview } from "./SyncRunsOverview.js";
import { PageHeader } from "./ui/PageHeader.js";

/** Unified sync health — Reagan + Pinnacle ops views on one page. */
export function SyncHealth() {
  return (
    <div className="space-y-10">
      <PageHeader
        title="Sync health"
        description="Monitor Kizen and Reagan sync runs and inspect cached upstream records."
      />
      <SyncRunsOverview />
      <section className="space-y-4">
        <h2 className="text-sm font-semibold uppercase tracking-wider text-content-muted">Pinnacle / Kizen cache</h2>
        <PinnacleData />
      </section>
      <section className="space-y-4">
        <h2 className="text-sm font-semibold uppercase tracking-wider text-content-muted">Reagan cache</h2>
        <ReaganData />
      </section>
    </div>
  );
}
